export default __webpack_public_path__ + "static/media/Bioinformatics.9269ef60.pdf";